var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCbEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.527 128C244.527 192.356 192.356 244.527 128 244.527C63.6439 244.527 11.473 192.356 11.473 128C11.473 63.6439 63.6439 11.473 128 11.473C192.356 11.473 244.527 63.6439 244.527 128Z",
    fill: "white",
    stroke: "#0052FF",
    strokeWidth: 22.946
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.975 31.999V100.017L183.952 125.705L127.975 31.999Z",
    fill: "#0052FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.983 31.999L71.998 125.705L127.983 100.017V31.999Z",
    fill: "#6697FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.975 169.782V215.999L183.99 136.41L127.975 169.782Z",
    fill: "#0052FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.983 215.999V169.775L71.998 136.41L127.983 215.999Z",
    fill: "#6697FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.975 159.084L183.952 125.704L127.975 100.03V159.084Z",
    fill: "#6697FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.998 125.704L127.983 159.084V100.03L71.998 125.704Z",
    fill: "#CCDCFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbEth);
export default __webpack_public_path__ + "static/media/cbETH.ce1cdccc0e46951927cc55c77c10fa1d.svg";
export { ForwardRef as ReactComponent };